import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Community } from "../../../shared";

@Component({
  selector: "community-viewer",
  templateUrl: "./community-viewer.component.html",
  styleUrls: [
    "./community-viewer.component.scss",
    "../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class CommunityViewerComponent implements OnInit {
  public community: Community;
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.data.subscribe((data: { community: Community }) => {
      this.community = data.community;
    });
  }
}
